import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Row, Col, Alert } from 'react-bootstrap';

export default function UkiesForm({ componentSettings, setComponentSettings, onChange, selectedComponent, setSelectedComponent, forms = [] }) {
    const [isInitialized, setIsInitialized] = useState(false);

    // Get current values with defaults
    const selectedFormShortcode = componentSettings.form_shortcode || (forms.length > 0 ? forms[0].shortcode : '[form=1]');

    // Parse HTML content to extract form configuration
    const parseHTMLContent = (htmlContent) => {
        if (!htmlContent) return null;
        
        try {
            // Look for form shortcode pattern [form=ID]
            const formMatch = htmlContent.match(/\[form=([^\]]+)\]/);
            
            if (formMatch) {
                return {
                    form_shortcode: formMatch[0] // Full shortcode like [form=1]
                };
            }
            
            return null;
        } catch (error) {
            console.error('Error parsing HTML content:', error);
            return null;
        }
    };

    // Generate HTML content from current form values
    const generateHTMLContent = () => {
        return generateHTMLContentWithSettings(componentSettings);
    };

    // Generate HTML content with specific settings
    const generateHTMLContentWithSettings = (settings) => {
        const formShortcode = settings.form_shortcode || selectedFormShortcode;
        
        return `<div class="ukies-form">${formShortcode}</div>`;
    };

    // Initialize component settings from HTML content on first load
    useEffect(() => {
        if (!isInitialized && selectedComponent?.content) {
            const parsedData = parseHTMLContent(selectedComponent.content);
            if (parsedData) {
                const newSettings = {
                    form_shortcode: parsedData.form_shortcode || selectedFormShortcode
                };
                
                setComponentSettings(prev => ({
                    ...prev,
                    ...newSettings
                }));
            }
            setIsInitialized(true);
        } else if (!isInitialized) {
            // No existing content, initialize with defaults
            const newSettings = {
                form_shortcode: selectedFormShortcode
            };
            
            setComponentSettings(prev => ({
                ...prev,
                ...newSettings
            }));
            setIsInitialized(true);
        }
    }, [selectedComponent, isInitialized, selectedFormShortcode, setComponentSettings]);

    // Handle form selection change
    const handleFormChange = (shortcode) => {
        const newSettings = {
            ...componentSettings,
            form_shortcode: shortcode
        };
        
        setComponentSettings(newSettings);
        
        // Generate new HTML content and trigger onChange
        const newContent = generateHTMLContentWithSettings(newSettings);
        onChange('content', newContent);
    };

    // Get form name by shortcode for display purposes
    const getFormNameByShortcode = (shortcode) => {
        const form = forms.find(f => f.shortcode === shortcode);
        return form ? form.name : shortcode;
    };

    return (
        <div>
            {/* Form Selection */}
            <Form.Group className="mb-3">
                <Form.Label>Selecteer Formulier</Form.Label>
                <Form.Select
                    value={selectedFormShortcode}
                    onChange={(e) => handleFormChange(e.target.value)}
                >
                    {forms.length > 0 ? (
                        forms.map(form => (
                            <option key={form.shortcode} value={form.shortcode}>
                                {form.name}
                            </option>
                        ))
                    ) : (
                        <>
                            <option value="[form=1]">Formulier 1</option>
                            <option value="[form=2]">Formulier 2</option>
                            <option value="[form=3]">Formulier 3</option>
                            <option value="[form=4]">Formulier 4</option>
                            <option value="[form=5]">Formulier 5</option>
                        </>
                    )}
                </Form.Select>
                {forms.length === 0 && (
                    <Form.Text className="text-muted">
                        Formulieren worden geladen...
                    </Form.Text>
                )}
            </Form.Group>

            {/* Help Information */}
            <Alert variant="info" className="small" style={{ backgroundColor: '#e6ebea90', border: 'none', color: 'var(--ukies-dark-green)'}}>
                <Alert.Heading className="h6">Wat is een Formulier?</Alert.Heading>
                <p className="mb-0">
                    Formulieren zijn pre-gedefinieerde componenten die je kunt gebruiken om gegevens van bezoekers te verzamelen. Ze worden doormiddel van een shortcode in je website geplaatst. De inhoud van een formulier kun je hier niet aanpassen.<br/>
                    <br />
                    Formulieren kunnen verschillende velden bevatten zoals tekstvelden, e-mailvelden, selectielijsten en meer.
                </p>
            </Alert>
        </div>
    );
}